import { FrameData } from 'data/FlyerData';
import { FrameType } from 'data/FrameType';
import { createFrameFromData } from 'data/FrameUtils';
import { ModalType } from 'data/ModalData';
import { PictureFrame } from 'data/PictureFrame';
import { closeModal, openModal, REPLACE_FRAME } from 'state/actions';
import { getFrameById, getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { getBackgroundStyleFromImageFile, isUUID, loadFile } from 'utils';
import { callFunction } from 'utils/FirebaseUtils';
import {
  deleteFileWithUrl,
  getFileNameFromUrl,
  uploadAsset
} from 'utils/S3Utils';
import { Command, CommandFunction } from './Command';

export const removeBackground = async (
  fileOrUrl: File | string,
  trim: boolean = false
): Promise<string> => {
  let uploadedFile = false;
  let url: string;
  if (fileOrUrl instanceof File) {
    console.log('Upload file');
    url = await uploadAsset(fileOrUrl);
    uploadedFile = true;
  } else {
    url = fileOrUrl;
  }
  const fileName = getFileNameFromUrl(url);
  const cutoutFileName = (
    await callFunction('removeBackground', { fileName, trim })
  ).data;
  if (uploadedFile) {
    // delete uploaded file
    await deleteFileWithUrl(url);
  }
  return cutoutFileName;
};

export class RemoveBackgroundCommand extends Command {
  layerId: string;
  frameId: string;
  newFrameId: string;
  frameData: FrameData;
  file: File;
  constructor(layerId: string, frameId: string) {
    super();
    this.layerId = layerId;
    this.frameId = frameId;
    this.newFrameId = isUUID(frameId) ? Uuid.raw() : frameId;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = getFrameById(flyer, this.frameId);
      if (layer && frame && frame instanceof PictureFrame) {
        if (firstTime) {
          this.frameData = frame.asData(false);
          this.frameData.id = frame.id;
          dispatch(
            openModal(ModalType.Processing, 'Removing background', false, true)
          );
          const cutoutImageNameUrl = await removeBackground(
            frame.file || frame.url
          );
          const blob = await loadFile(cutoutImageNameUrl);
          this.file = new File([blob], 'cutout.png');
          // await deleteFile(cutoutImageName); // not needed with Removal.ai
          dispatch(closeModal());
        }
        const { resolution } = flyer;
        const newFrame = new PictureFrame(resolution.width, resolution.height);
        newFrame.id = this.newFrameId;
        newFrame.file = this.file;
        newFrame.filename = this.file.name;
        newFrame.type = FrameType.Image;
        newFrame.backgroundStyle = await getBackgroundStyleFromImageFile(
          this.file
        );
        await newFrame.load();
        newFrame.boundingBox = frame.boundingBox;
        dispatch({
          type: REPLACE_FRAME,
          layer,
          oldFrame: frame,
          newFrame
        });
      }
    };
  }
  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = getFrameById(flyer, this.newFrameId);
      if (layer && frame) {
        const newFrame = createFrameFromData(
          this.frameData,
          layer.stageWidth,
          layer.stageHeight
        );
        await newFrame.load();
        dispatch({
          type: REPLACE_FRAME,
          layer,
          oldFrame: frame,
          newFrame
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/RemoveBackgroundCommand.ts